<template>
  <v-card>
    <v-card-title
      >Avanço em massa ({{ avanco.quantidade }})</v-card-title
    >
    <v-card-text>
      <v-alert dense type="info">
        Processados: <strong>{{ avanco.processed }}</strong>
      </v-alert>
      <v-alert dense text type="success">
        Sucesso: <strong>{{ avanco.success }}</strong>
      </v-alert>
      <v-alert dense outlined type="error">
        Erro: <strong>{{ avanco.error }}</strong>
      </v-alert>
      <v-divider />
      <v-card-actions class="justify-end">
        <v-btn
          color="error"
          @click="$emit('close')"
          :disabled="avanco.processed < avanco.quantidade"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ModalAvancandoCaminhoes',

  props: {
    avanco: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>
